import styled from '@emotion/styled';
import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

export const SelectLabel = styled.div`
  text-align: left;
  margin-bottom: ${spacing.xxSmall};
`;

export const CalloutContainer = styled.section`
  margin-top: ${spacing.medium};
  margin-bottom: ${spacing.medium};
`;

export const Container = styled.div`
  padding-top: ${spacing.large};

  > ${SelectLabel}:not(:first-of-type) {
    margin-top: ${spacing.xLarge};
  }

  > ${CalloutContainer}:first-of-type {
    margin-top: ${spacing.xLarge};
  }
`;

export const Sample = styled.div`
  height: 14px;
  width: 100%;
  text-align: left;
  font-size: 12px;
  line-height: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: ${COLORS.shadow5};
  margin-top: ${spacing.xxSmall};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`;
